module.exports = __webpack_public_path__ + "img/brands_image_1.ee73a60e.png";